import { useQuery } from "react-query";
import { apiGetSetting } from "../api/settings/apiGetSetting";

const MAINTENANCE_SETTING_KEY =
  process.env.REACT_APP_AFFINITY === "true"
    ? "GLOBAL_MAINTENANCE_AFFINITY_ENABLED"
    : "GLOBAL_MAINTENANCE_JOB_PORTAL_ENABLED";

const MAINTENANCE_POLL_INTERVAL_MS = 60000;

/**
 * Consulta periódicamente el ajuste global de mantenimiento del producto
 * actual (portal de empleo o Affinity) y devuelve si está activo.
 *
 * Fail-open: mientras carga o si la petición falla, devuelve `false` para no
 * bloquear la aplicación.
 */
export default function useGlobalMaintenanceQuery() {
  const { data } = useQuery(
    ["globalMaintenance", MAINTENANCE_SETTING_KEY],
    () => apiGetSetting(MAINTENANCE_SETTING_KEY),
    {
      refetchInterval: MAINTENANCE_POLL_INTERVAL_MS,
      refetchIntervalInBackground: true,
    }
  );

  return data?.value === "true";
}
